<template>
  <v-row>
    <v-col class="text-center kbGrayText--text" cols="12" >
      <h3>{{ $t('general.uploadFileTypeInfo') }}</h3>
    </v-col>

    <v-col class="pa-2 text-center"
           cols="12"
           v-if="!importerFile">
      <v-btn
        :color="color"
        dark
        large
        @click="pickFile()"
      >
        <v-icon left>insert_drive_file</v-icon>
        {{ $t('general.pickFile') }}
      </v-btn>

      <input
        accept=".csv, .xlsx, .xls"
        class="d-none"
        ref="fileInput"
        type="file"
        @change="onFilePicked"
      >
    </v-col>

    <v-col
      class="primary--text"
      cols="12"
      v-if="importerFile"
    >
      <v-row justify="center" align="center">
        <h4 class="d-inline">
          {{importerFile.name}}
        </h4>
        <v-btn
          class="ml-4"
          icon
          color="error"
          @click="clearFile()"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    importerFile: {
      get () {
        return this.$store.state.listsPersons.importer.file
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_FILE', value)
      }
    }
  },
  methods: {
    clearFile () {
      this.importerFile = null
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const file = event.target.files[0]
      const filename = file.name
      if (filename.lastIndexOf('.') <= 0) {
        return window.alert(this.$t('general.pleaseAddAValidFile'))
      }
      if (file) this.importerFile = file
    }
  },
  props: {
    color: {
      type: String
    }
  }
}
</script>
